var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M18.3 9.9l-7.4 7.4c-.3.3-.7.4-1.1.4h-.1-.1c-.4 0-.8-.1-1.1-.4l-3.1-3.1c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l2.1 2.1L16 7.8c.6-.6 1.5-.6 2.1 0s.8 1.5.2 2.1M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/success.svg